import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.scss";
import { showPopup } from "../../../redux/action-creaters/popup";
import { popupTypes } from "../../../redux/reducers/popupReducer";
import useIsMobile from "../../../hooks/useIsMobile";

export default function Video() {
  const { mainSlider } = useSelector((state) => state.content);
  const slider = mainSlider[0];
  const dispatch = useDispatch();
  const { isMobile } = useIsMobile();

  return (
    <div className={styles.Video}>
      <div className={"container"}>
        <div className={styles.Content}>
          <h1>{slider.NAME}</h1>
          <div
            className={styles.Title}
            dangerouslySetInnerHTML={{ __html: slider.PREVIEW_TEXT }}
          ></div>
          <div
            className={styles.Full}
            onClick={() => {
              dispatch(
                showPopup(
                  popupTypes.videoFull,
                  "https://rutube.ru/play/embed/b511f3f5ac1b78ed7cad46d6611e7bb4?skinColor=0e8dee",
                ),
              );
            }}
          >
            Смотреть полное видео
          </div>
        </div>
      </div>
      {isMobile && (
        <iframe
          className={styles.VideoMobile}
          src="https://kinescope.io/embed/rXxDPyn3YfHSqr1F7rupHD"
          allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
      {!isMobile && (
        <iframe
          className={styles.VideoDesktop}
          src="https://kinescope.io/embed/2vfHifdVrTzFUpi8sXZrKJ"
          allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
    </div>
  );
}
